import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../utils/helpers";

interface TenantInsuranceProps {
    isOpen: boolean;
    onClose: () => void;
}

const TenantInsurance: React.FC<TenantInsuranceProps> = ({
    isOpen,
    onClose,
}) => {
    const squareOneLogo = toAbsoluteUrl("images/insurance/square-one-logo.svg");
    const westlandLogo = toAbsoluteUrl("images/insurance/westland-express-logo.svg");

    const modalStyles = {
        backdropFilter: 'blur(5px)',
    };

    const logoContainerStyle = {
        backgroundColor: "#ffffff",
        padding: "30px 20px",
        borderRadius: "15px",
        width: "220px",
        height: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        border: "2px solid transparent",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
        margin: "0 auto",
    };

    const logoHoverStyle = {
        transform: "translateY(-5px)",
        boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
        borderColor: "#e3f2fd",
    };

    const buttonBaseStyle = {
        fontWeight: "600",
        fontSize: "1.1rem",
        borderRadius: "12px",
        padding: "14px 24px",
        border: "none",
        transition: "all 0.3s ease",
        textDecoration: "none",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        textTransform: "uppercase" as const,
        letterSpacing: "0.5px",
    };

    const squareOneButtonStyle = {
        ...buttonBaseStyle,
        backgroundColor: "#ff6b35",
        color: "white",
    };

    const westlandButtonStyle = {
        ...buttonBaseStyle,
        backgroundColor: "#20b2aa",
        color: "white",
    };

    const handleLogoClick = (url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            <style>{`
                .modal-backdrop {
                    backdrop-filter: blur(5px) !important;
                }
                
                .enhanced-modal .modal-content {
                    border: none;
                    border-radius: 20px;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    overflow: hidden;
                    position: relative;
                }

                .floating-close-btn {
                    background: rgba(255, 255, 255, 0.9) !important;
                    border: none !important;
                    border-radius: 50% !important;
                    width: 40px !important;
                    height: 40px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    cursor: pointer !important;
                    transition: all 0.3s ease !important;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15) !important;
                    position: absolute !important;
                    top: 20px !important;
                    right: 20px !important;
                    z-index: 1050 !important;
                    opacity: 0.8 !important;
                }

                .floating-close-btn:hover {
                    background: rgba(255, 255, 255, 1) !important;
                    transform: rotate(90deg) scale(1.1) !important;
                    opacity: 1 !important;
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25) !important;
                }

                .floating-close-btn svg {
                    width: 20px !important;
                    height: 20px !important;
                    color: #6c757d !important;
                    transition: color 0.3s ease !important;
                }

                .floating-close-btn:hover svg {
                    color: #495057 !important;
                }

                .enhanced-modal .modal-body {
                    padding: 60px 35px 40px;
                    position: relative;
                }

                .enhanced-modal .modal-title {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    font-weight: 800;
                    font-size: 2.2rem;
                    margin-bottom: 1.5rem;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
                }

                .enhanced-modal .modal-subtitle {
                    color: #495057;
                    font-size: 1.15rem;
                    line-height: 1.7;
                    margin-bottom: 2.5rem;
                    font-weight: 400;
                }

                .logo-container {
                    position: relative;
                    overflow: hidden;
                }

                .logo-container::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
                    transition: left 0.6s ease;
                }

                .logo-container:hover::before {
                    left: 100%;
                }

                .insurance-btn {
                    position: relative;
                    overflow: hidden;
                    transform: perspective(1px) translateZ(0);
                    transition: all 0.3s ease;
                }

                .insurance-btn::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                    transition: left 0.6s ease;
                }

                .insurance-btn:hover::before {
                    left: 100%;
                }

                .square-one-btn:hover {
                    background-color: #e55a2b !important;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4) !important;
                }

                .westland-btn:hover {
                    background-color: #1a9d96 !important;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 25px rgba(32, 178, 170, 0.4) !important;
                }

                .insurance-card {
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 20px;
                    padding: 25px;
                    height: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .insurance-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #667eea, #764ba2);
                    transform: scaleX(0);
                    transition: transform 0.3s ease;
                }

                .insurance-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
                }

                .insurance-card:hover::before {
                    transform: scaleX(1);
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                }

                .floating-icon {
                    animation: float 3s ease-in-out infinite;
                }
            `}</style>

            <Modal
                show={isOpen}
                onHide={onClose}
                centered
                size="lg"
                backdrop="static"
                className="enhanced-modal"
                style={modalStyles}
            >
                {/* Floating Close Button */}
                <button
                    className="floating-close-btn"
                    onClick={onClose}
                    aria-label="Close"
                    type="button"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <Modal.Body className="text-center">
                    <div className="floating-icon mb-4">
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="url(#grad1)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 22V12H15V22" stroke="url(#grad1)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <defs>
                                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#667eea" />
                                    <stop offset="100%" stopColor="#764ba2" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    <h2 className="modal-title">
                        Make Your Home Secure & Stress-Free!
                    </h2>

                    <p className="modal-subtitle">
                        Secure your rental with ease! Choose Square One for personalized coverage or Westland
                        Express for fast, reliable protection. Sign up today and enjoy peace of mind at home!
                    </p>

                    <Row className="g-4">
                        {/* Square One */}
                        <Col md={6}>
                            <div className="insurance-card">
                                <div className="d-flex justify-content-center mb-4">
                                    <div
                                        className="logo-container"
                                        style={logoContainerStyle}
                                        onClick={() => handleLogoClick("https://www.squareone.ca/rentdigi")}
                                        onMouseEnter={(e) => {
                                            Object.assign(e.currentTarget.style, logoHoverStyle);
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.08)";
                                            e.currentTarget.style.borderColor = "transparent";
                                        }}
                                    >
                                        <img
                                            src={squareOneLogo}
                                            alt="Square One Insurance"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "60px",
                                                objectFit: "contain",
                                                transition: "all 0.3s ease"
                                            }}
                                        />
                                    </div>
                                </div>
                                <Button
                                    href="https://www.squareone.ca/rentdigi"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-100 insurance-btn square-one-btn"
                                    style={squareOneButtonStyle}
                                >
                                    Get Square One Now!
                                </Button>
                            </div>
                        </Col>

                        {/* Westland Express */}
                        <Col md={6}>
                            <div className="insurance-card">
                                <div className="d-flex justify-content-center mb-4">
                                    <div
                                        className="logo-container"
                                        style={logoContainerStyle}
                                        onClick={() => handleLogoClick("https://www.westlandexpress.ca/tenant-insurance/")}
                                        onMouseEnter={(e) => {
                                            Object.assign(e.currentTarget.style, logoHoverStyle);
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.08)";
                                            e.currentTarget.style.borderColor = "transparent";
                                        }}
                                    >
                                        <img
                                            src={westlandLogo}
                                            alt="Westland Express Insurance"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "60px",
                                                objectFit: "contain",
                                                transition: "all 0.3s ease"
                                            }}
                                        />
                                    </div>
                                </div>
                                <Button
                                    href="https://www.westlandexpress.ca/tenant-insurance/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-100 insurance-btn westland-btn"
                                    style={westlandButtonStyle}
                                >
                                    Try Westland Today!
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { TenantInsurance };